import React from "react";

// Component for 404 errors
const NotFound = () => {
  return (
    <li className="not-found">
      <h3>The page your requested does not exist</h3>
    </li>
  );
};

export default NotFound;
